/**
 * Telefones brasileiros. O WhatsApp identifica o cliente pelo `wa_id` (só
 * dígitos, com DDI) e o ERP guarda o telefone do jeito que foi digitado, então
 * toda comparação passa por aqui.
 *
 * Celulares antigos chegam pela Meta sem o nono dígito ("558499630057" em vez
 * de "5584996300574"); `variantesTelefone` devolve as duas formas para a busca
 * no ERP não perder o cliente.
 */

/** "(84) 99630-0574" | "84996300574" | "+55 84 99630-0574" -> "5584996300574". */
export function normalizarTelefone(telefone: string): string | null {
  const d = telefone.replace(/\D/g, "");
  if (!d) return null;
  if (d.startsWith("55") && (d.length === 12 || d.length === 13)) return d;
  if (d.length === 10 || d.length === 11) return `55${d}`;
  // Número estrangeiro já com DDI: aceita como veio.
  if (!d.startsWith("55") && d.length >= 8 && d.length <= 15) return d;
  return null;
}

/** Formas equivalentes do mesmo celular brasileiro (com e sem o nono dígito). */
export function variantesTelefone(telefone: string): string[] {
  const n = normalizarTelefone(telefone);
  if (!n) return [];
  if (!n.startsWith("55")) return [n];
  const ddd = n.slice(2, 4);
  const local = n.slice(4);
  if (local.length === 9 && local.startsWith("9")) return [n, `55${ddd}${local.slice(1)}`];
  if (local.length === 8 && /^[6-9]/.test(local)) return [n, `55${ddd}9${local}`];
  return [n];
}

/** "5584996300574" -> "(84) 99630-0574". */
export function formatarTelefone(telefone: string): string {
  const n = normalizarTelefone(telefone);
  if (!n || !n.startsWith("55")) return telefone;
  const ddd = n.slice(2, 4);
  const local = n.slice(4);
  const corte = local.length - 4;
  return `(${ddd}) ${local.slice(0, corte)}-${local.slice(corte)}`;
}
